module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/time.svg?0e3f3bcf5b2894a6904a14466b638152";